var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPinOutlineinline = function SvgMapPinOutlineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.2-2.2 2.2zM3 9c0 3.2 2.6 7.9 7.8 14.4.6.8 1.7.8 2.3 0C18.4 16.9 21 12.2 21 9c0-5-4-9-9-9S3 4 3 9zm9-6c3.3 0 6 2.7 6 6 0 2.1-2 5.9-6 11.1-4-5.2-6-9-6-11.1 0-3.3 2.7-6 6-6z"
  })));
};
export default SvgMapPinOutlineinline;